import React, { useState, useEffect, useContext } from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../components/Loading.jsx";
import DataTable from "react-data-table-component";
import { FaEdit, FaTrash, FaEye, FaBorderAll } from "react-icons/fa";
import { TfiMenuAlt, } from "react-icons/tfi";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../context/DealerProfile.jsx";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import useSWR, { mutate } from "swr";
import { Bell, Cake, X } from 'lucide-react'
import { useLocation } from "react-router-dom";
// import { Pagination } from "flowbite-react";
import { AllStates } from "../context/globalState.jsx";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <div className="flex flex-wrap justify-center items-center gap-2 mt-4 mr-[45px]">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Previous
      </button>


      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </div>
  );
};


export default function ContactsTable() {
  const { dealerDetail } = useUserContext();
  const { allState, allStatedispatch } = useContext(AllStates);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [lead, setLead] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alternatePhoneError, setAlternatePhoneError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.name)); // Default: Show all columns
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(250);




  // When initializing
  const [searchValues, setSearchValues] = useState(() => {
    const saved = JSON.parse(localStorage.getItem("Callspagination")) || {};
    return {
      limit: saved.limit || 10,
      page: saved.page || 1,
    };
  });

  // When updating
  useEffect(() => {
    localStorage.setItem("Callspagination", JSON.stringify(searchValues));
  }, [searchValues]);



  const [selectedRow, setSelectedRow] = useState(null); // Optional


  const [leadSourceOptions, setLeadSourceOptions] = useState([]);

  // const [callRemarks, setCallRemarks] = useState("");


  // -------- all state function 


  const fetchPicklistOptions = async (fieldId, setOptions) => {
    try {
      const res = await fetch(
        `/server/dealer_backend/getPickListValues/${fieldId}?module=Contacts&type=used`
      );
      const result = await res.json();
      if (result.status === "success") {

        setOptions(result.data || []);
        const key = `picklist-${fieldId}`
        allStatedispatch({
          type: "add",
          payload: { [key]: result?.data },
        })

      } else {
        console.error("Failed to fetch picklist:", result.error);
      }
    } catch (err) {
      console.error("Error fetching picklist:", err);
    }
  };

  // useEffect(() => {

  //     const picklistMap = [
  //         { key: 'picklist-760958000001085586', action: () => fetchPicklistOptions("760958000001085586", setDonationOptions), onData: setDonationOptions },
  //         { key: 'picklist-760958000004566661', action: () => fetchPicklistOptions("760958000004566661", setContactPreferencesOptions), onData: setContactPreferencesOptions },
  //         { key: 'picklist-760958000004425144', action: () => fetchPicklistOptions("760958000004425144", setCallDispositionOptions), onData: setCallDispositionOptions },
  //     ]

  //     // if(!allState['picklist-760958000001085586']){
  //     //     fetchPicklistOptions("760958000001085586", setDonationOptions);        // Donation Purpose
  //     // }else{
  //     //     setDonationOptions(allState['picklist-760958000001085586'])
  //     // }
  //     // if(!allState['picklist-760958000004566661']){
  //     //     fetchPicklistOptions("760958000004566661", setContactPreferencesOptions); // Contact Preferences
  //     // }
  //     // if(!allState['picklist-760958000004425144']){
  //     //     fetchPicklistOptions("760958000004425144", setCallDispositionOptions);   // Call Dispositions
  //     // }

  //     picklistMap.forEach(ob => {
  //         if (!allState[ob?.key]) {
  //             console.log("fetching : ", ob.key)
  //             ob.action();
  //         } else {
  //             ob.onData(allState[ob?.key]);
  //         }
  //     })

  //     console.log("---- PICKLIST ----")
  //     console.log(allState['picklist-760958000001085586'])
  //     console.log(allState['picklist-760958000004566661'])
  //     console.log(allState['picklist-760958000004425144'])
  //     console.log(allState)
  //     // fetchPicklistOptions("760958000000407488", setLeadSourceOptions); // IFR Lead Source
  // }, []);

  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredLead, setFilteredLead] = useState([]);

  const openModal = () => {
    setPrevSelectedColumns(selectedColumns); // Save current state before changes
    setIsModalOpen(true);
  };
  const columns = [
    {
      name: "Call ID",
      selector: row => row.Call_ID ?? "",      // plain string used for sorting
      cell: row => (
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: "#5A5A5C",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={e => (e.target.style.color = "blue")}
          onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
          onClick={() => navigate(`/call-details/${row.id}`)}
        >
          {row?.Call_ID}
        </span>
      ),
      sortable: true,
      wrap: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "200px",
    },
    {
      name: "Donor Name",
      selector: row => row.Name ?? "",          // plain string for sorting
      cell: row => (
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: "#5A5A5C",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={e => (e.target.style.color = "blue")}
          onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
          onClick={() => navigate(`/call-details/${row.id}`)}
        >
          {row?.Name}
        </span>
      ),
      sortable: true,
      wrap: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "200px",
    },
    {
      name: "Call Disposition",
      selector: row => row.Call_Status ?? "",   // plain string for sorting
      cell: row => (
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: "#5A5A5C",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={e => (e.target.style.color = "blue")}
          onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
          onClick={() => navigate(`/call-details/${row.id}`)}
        >
          {row?.Call_Status}
        </span>
      ),
      sortable: true,
      wrap: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "200px",
    },
    {
      name: "Email",
      selector: row => row.Email ?? "",
      sortable: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "250px",
    },

  ];





  // const [catalystUsers, setCatalystUsers] = useState([]);

  // useEffect(() => {
  //   const fetchCatalystUsers = async () => {
  //     if (allState["CatalystUser"]) {
  //       setCatalystUsers(allState["CatalystUser"]);

  //       return
  //     }
  //     try {
  //       const response = await fetch("/server/dealer_backend/getCatalystUsers");
  //       const data = await response.json();
  //       // console.log(data)
  //       if (data.status === "success") {
  //         setCatalystUsers(data.data);
  //         allStatedispatch({
  //           type: "add",
  //           payload: { "CatalystUser": data.data },
  //         })
  //       } else {
  //         console.error("Failed to fetch Catalyst Users:", data.error);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching Catalyst Users:", error);
  //     }
  //   };

  //   fetchCatalystUsers();
  // }, []);


  const [selectedColumns, setSelectedColumns] = useState([]);


  // State to track the most recently clicked column
  const [lastClickedColumn, setLastClickedColumn] = useState(null);
  const [initialColumns, setInitialColumns] = useState([]); // Track initial columns state


  // Fetch columns from localStorage or default columns when component mounts
  useEffect(() => {
    const storedColumns = localStorage.getItem("selectedColumnsCalls");

    if (storedColumns) {
      // If columns are found in localStorage, use them
      const parsedColumns = JSON.parse(storedColumns);
      setSelectedColumns(parsedColumns);
      setInitialColumns(parsedColumns); // Save the initial state
    } else {
      // Otherwise, use default columns (this is assuming 'columns' is your default set)
      const defaultColumns = columns.map(col => col.name);
      setSelectedColumns(defaultColumns);
      setInitialColumns(defaultColumns); // Save the initial state
    }
  }, []);
  // const [error, setError] = useState(false);






  // const currentPage = page || 1;
  //    const currentPage = page || 1;
  const pageSize = limit || 20;
  const total = totalRecords || 0;

  const start = total === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = Math.min(start + pageSize - 1, total);




  const formatDateForBackend = (dateInput) => {
    if (!dateInput) return "";

    const date = new Date(dateInput);

    const pad = (n) => n.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const offset = -date.getTimezoneOffset(); // Note the sign flip
    const sign = offset >= 0 ? "+" : "-";
    const absOffset = Math.abs(offset);
    const offsetHours = pad(Math.floor(absOffset / 60));
    const offsetMinutes = pad(absOffset % 60);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
  };

  const location = useLocation();



  // Initialize createdDate from localStorage or null
  const [createdDate, setCreatedDate] = useState(() => {
    return localStorage.getItem('createdDate') || '';
  });

  // const [currentPage, setCurrentPage] = useState(() => {
  //   const savedPage = parseInt(localStorage.getItem('page') || '1', 10);
  //   return isNaN(savedPage) || savedPage < 1 ? 1 : savedPage;
  // });

  // Whenever createdDate/currentPage changes → persist into localStorage
  useEffect(() => {
    if (createdDate) {
      localStorage.setItem('createdDate', createdDate);
    } else {
      localStorage.removeItem('createdDate');
    }
    localStorage.setItem('page', currentPage.toString());

    // Optional: Clean the URL so it doesn't keep old query params
    if (location.search) {
      navigate(location.pathname, { replace: true });
    }
  }, [createdDate, currentPage, location.search, location.pathname, navigate]);



  // 1. Fetch and set contacts
  const fetchContacts = async (filters = {}) => {
    setIsLoading(true);

    const {
      createdate = createdDate, // same name as in onChange
    } = filters;

    let t = '';
    [createdate].forEach(f => {
      t = `${f}-${t}`;
    });

    const key = `call-contacts-${searchValues.page}-${searchValues.limit}-${t}${dealerDetail?.Email}`;

    if (allState[key]) {
      setLeads(allState[key]?.data);
      setTotalRecords(allState[key]?.total);
      setIsLoading(false);
      return;
    }

    try {
      const res = await fetch("/server/dealer_backend/getAllCalls", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          page: searchValues.page,
          limit: searchValues.limit,
          dealerEmail: dealerDetail?.Email,
           listName : dealerDetail?.List_Name,
          selectedDate: createdate // backend expects this name
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        let allLeads = (data.data || []).sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
        allStatedispatch({
          type: "add",
          payload: { [key]: { data: allLeads, total: data.pagination.totalRecords } }
        });
        setLeads(allLeads);
        setTotalRecords(data.pagination.totalRecords);
      } else {
        setLeads([]);
      }
    } catch (error) {
      console.error("Error fetching calls:", error);
      setLeads([]);
    } finally {
      setIsLoading(false);
    }
  };





  useEffect(() => {
    fetchContacts();
  }, [searchValues.page, searchValues.limit, dealerDetail?.Email]);

















  // console.log({ leads })










  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    setSearchValues((prev) => ({
      ...prev,
      page: newPage
    }));
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  // const [birthdayLeads, setBirthdayLeads] = useState([]);



  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  }



  function MobileDonorCard({ donor }) {
    return (
      <Link to={`/call-details/${donor.id}`}>
        <div className="bg-white shadow-md ml-[-43px] rounded-xl p-4 mb-4 w-[120%] hover:bg-gray-50 transition cursor-pointer">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg">
                {`${donor.Name ?? ''}`.trim().charAt(0) || 'D'}

              </div>
              <div>
                <p className="font-semibold text-gray-900"> {`${donor.Name || ''}`.trim()}</p>
                {/* <p className="text-xs text-gray-500">{donor.id}</p> */}
              </div>
            </div>
            <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full font-semibold ">
              {donor.Call_Status || ''}
            </span>
          </div>

          <hr className="my-2" />

          <div className="text-sm text-gray-700">
            <div className="flex justify-between mb-1">
              <span className="text-gray-500">Email</span>
              <span>{donor.Email || 'N/A'}</span>
            </div>

          </div>
        </div>
      </Link>
    );
  }



  // const [totalRecords, setTotalRecords] = useState(0);





  const isMobile = useIsMobile();




  const [loading, setLoading] = useState(true);






  useEffect(() => {
    setRowsPerPage(searchValues.limit);
    setCurrentPage(searchValues.page);
  }, [searchValues]);








  // useEffect(() => {
  //     fetchContacts({
  //         page: currentPage,
  //         limit: rowsPerPage,
  //         filters: {
  //             // any filters like disposition, campaign, etc.
  //         }
  //     });
  // }, [currentPage, rowsPerPage, selectedDisposition, selectedCampaignName, debouncedEmailFilter, debouncedPhoneFilter, debouncedDonorNameFilter]);


  const OFFSET = (searchValues.page - 1) * searchValues.limit;
  // Function to apply filters (save to localStorage)
  const applyFilter = () => {
    try {
      // Ensure only primitive values (strings) are stored
      const safeColumns = selectedColumns.map(col => String(col));
      localStorage.setItem("selectedColumnsCalls", JSON.stringify(safeColumns));
    } catch (error) {
      // console.error("Error saving to localStorage:", error);
    }

    setIsModalOpen(false);
  };

  const [prevSelectedColumns, setPrevSelectedColumns] = useState([]); // Store previous state



  // Function to reset filter by restoring the saved state
  const resetFilter = () => {
    setSelectedColumns(prevSelectedColumns); // Restore previous selection
    setIsModalOpen(false);
  };

  // Function to handle column changes
  const handleColumnChange = (colName) => {
    setSelectedColumns((prev) => {
      const updatedColumns = prev.includes(colName)
        ? prev.filter((name) => name !== colName)
        : [...prev, colName];

      try {
        // Ensure only primitive values (strings) are stored
        const safeColumns = updatedColumns.map(col => String(col));
        localStorage.setItem("selectedColumnsCalls", JSON.stringify(safeColumns));
      } catch (error) {
        // console.error("Error saving to localStorage:", error);
      }

      // Track the most recent checkbox clicked
      setLastClickedColumn(colName);

      return updatedColumns;
    });
  };

  const filteredColumns = columns.filter(
    col => selectedColumns.includes(col.name) || typeof col.name === "object"
  );


  return (
    <div className="p-6 space-y-6 text-gray-800">

      {/* Manage Columns Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setIsModalOpen(false)}
          aria-modal="true"
          role="dialog"
          aria-labelledby="manage-columns-title"
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 id="manage-columns-title" className="text-xl font-bold mb-5">
              Manage Columns
            </h2>

            {/* Search Input */}
            <input
              type="text"
              placeholder="Search columns..."
              className="w-full p-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Search columns"
            />

            {/* Column List with Scroll */}
            <div className="max-h-60 overflow-auto border border-gray-200 rounded p-3">
              {columns
                .filter(col => typeof col.name === "string")
                .filter(col => col.name.toLowerCase().includes(searchTerm.toLowerCase()))
                .map((col, index) => {
                  const isLastName = col.name === "Last Name";
                  return (
                    <label
                      key={index}
                      className={`flex items-center mb-3 cursor-pointer select-none ${isLastName ? "opacity-50 cursor-not-allowed" : "hover:text-blue-600"
                        }`}
                    >
                      <input
                        type="checkbox"
                        className="mr-3"
                        disabled={isLastName}
                        checked={selectedColumns.includes(col.name)}
                        onChange={() => !isLastName && handleColumnChange(col.name)}
                      />
                      <span>{col.name}</span>
                    </label>
                  );
                })}
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={resetFilter}
                className="px-5 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={applyFilter}
                className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Table header */}
      <div className="flex flex-wrap gap-2 justify-between items-center px-2 md:px-6 mb-4">
        {/* Created Time Filter - Left */}
        <div className="flex items-center gap-1 flex-wrap w-full max-w-full md:w-auto">
          <label
            htmlFor="createdDate"
            className="text-gray-700 font-medium select-none whitespace-nowrap text-sm sm:text-base"
          >
            Created Time:
          </label>
          <input
            id="createdDate"
            type="date"
            value={createdDate || ""}
            onChange={(e) => {
              const newValue = e.target.value;
              setCreatedDate(newValue);
              setCurrentPage(1);
              fetchContacts({ createdate: newValue }); // match param to API requirement
            }}
            className="border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400 transition shadow-sm text-sm sm:text-base"
            style={{ minWidth: 0 }}
          />
        </div>

        {/* Manage Columns Button - Right */}
        {/* <div className="relative group hidden md:inline-flex">
          <button
            onClick={openModal}
            type="button"
            className="p-2 bg-white shadow rounded-md hover:text-blue-600 transition text-blue-500"
            aria-label="Manage columns"
          >
            <TfiMenuAlt className="text-xl" />
          </button>
          <div
            className="absolute left-1/2 -translate-x-1/2 top-full mt-2 bg-gray-800 text-white text-xs rounded px-2 py-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10"
            role="tooltip"
          >
            Manage Columns
          </div>
        </div> */}
      </div>


      {/* Loading State */}
      {isLoading ? (
        <div className="flex justify-center items-center gap-3 py-10 text-blue-600" role="status" aria-live="polite">
          <svg
            className="animate-spin h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
          Loading Data...
        </div>
      ) : leads.length === 0 ? (
        <div className="text-center py-10 text-blue-600 font-medium">
          No data available
        </div>
      ) : isMobile ? (
        <div className="px-4 space-y-4">
          {leads.map((donor, index) => (
            <MobileDonorCard key={index} donor={donor} />
          ))}
        </div>
      ) : (
        <>
          {/* DataTable */}
          <div className="relative overflow-auto rounded-lg shadow border border-gray-200">
            <button
              onClick={openModal}
              aria-label="Manage columns"
              className="hidden md:flex group absolute top-3 right-3 items-center gap-2 px-3 py-2
                bg-white shadow mt-[-14.09px] mr-[-17px] hover:text-[#2070B9] transition text-[#2070B9] z-10 border-l-2 border-black"
              type="button"
            >
              <TfiMenuAlt className="text-lg" />

              {/* Tooltip */}
              <span className="absolute top-[-35px] right-0 opacity-0 group-hover:opacity-100 transition bg-black text-white text-xs rounded px-2 py-1 shadow whitespace-nowrap">
                Manage Columns
              </span>
            </button>
            <DataTable
              columns={filteredColumns}
              data={leads}
              fixedHeader
              dense
              responsive
              highlightOnHover
              progressPending={isLoading}
              className="custom-table text-base"
              onRowClicked={(row) => navigate(`/call-details/${row.id}`)}
              customStyles={{
                headCells: { style: { fontSize: "16px", fontWeight: "700", background: "#F3F7FA", color: "#1e3a8a" } },
                cells: { style: { whiteSpace: "nowrap", overflow: "visible", fontSize: "15px" } },
                rows: {
                  style: {
                    transition: "background 0.2s",
                    "&:hover": { background: "#ebf4ff" },
                  },
                },
              }}
              style={FaBorderAll}
            />
          </div>

          {/* Pagination */}
          <div className="mt-6 flex flex-wrap justify-between items-center gap-6 px-2 ">
            {/* Entry Count */}
            <div className="flex items-center text-gray-700 text-sm md:text-base">
              <span className="font-medium mr-1">Showing</span>
              <span className="px-2 py-1 bg-blue-100 text-blue-700 font-semibold rounded-lg">
                {`${(currentPage - 1) * rowsPerPage + 1}–${Math.min(
                  currentPage * rowsPerPage,
                  totalRecords
                )}`}
              </span>
              <span className="ml-1">of {totalRecords} entries</span>
            </div>

            {/* Records per Page */}
            <div className="flex items-center gap-2">
              <label
                htmlFor="recordsPerPage"
                className="text-gray-700 font-medium select-none"
              >
                Per page:
              </label>
              <select
                id="recordsPerPage"
                value={searchValues.limit}
                onChange={(e) =>
                  setSearchValues((prev) => ({
                    ...prev,
                    limit: Number(e.target.value),
                  }))
                }

                className="border border-gray-300 rounded-lg px-3 py-1.5 shadow-sm bg-white 
                 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              >
                {[10, 25, 50, 100].map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </select>
            </div>

            {/* Pagination */}
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(totalRecords / rowsPerPage)}
              onPageChange={onPageChange}
            />
          </div>
        </>
      )}
    </div>
  );

}
